module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), (!_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "maxlength": _vm.maxlength,
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "maxlength": _vm.maxlength,
      "type": "text",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3b919a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/fields/FieldVarchar.vue
// module id = 564
// module chunks = 1